(() => {
  const configNode = document.getElementById('CbnHalloweenAnalytics');
  if (!configNode || window.cbnHalloweenAnalyticsReady) return;
  window.cbnHalloweenAnalyticsReady = true;
  const config = JSON.parse(configNode.textContent);
  const seen = new WeakSet();
  const visible = new Set();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const publish = (name, detail) => {
    if (config.preview || !allowed()) return false;
    const payload = { campaign_id: 'halloween_2026', theme_id: config.themeId, locale: config.locale, ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
    try {
      window.Shopify?.analytics?.publish?.('crafty:' + name, payload);
    } catch {}
    return true;
  };
  const recordView = (element) => {
    if (seen.has(element)) return;
    const name = element.matches('[data-cbn-halloween-list]') ? 'cbn_halloween_list_view' : 'cbn_halloween_hero_view';
    if (publish(name, { item_ids: config.itemIds })) seen.add(element);
  };
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.intersectionRatio >= 0.2) {
        visible.add(entry.target);
        recordView(entry.target);
      } else visible.delete(entry.target);
    }
  }, { threshold: [0, 0.2] });
  const observe = () => document.querySelectorAll('[data-cbn-halloween-list], .cbn-home-hero').forEach((node) => observer.observe(node));
  observe();
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('visitorConsentCollected', () => visible.forEach(recordView));
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a');
    if (link?.dataset.cbnCampaignAction) {
      publish('cbn_halloween_cta_click', { placement: link.dataset.cbnCampaignAction, destination: new URL(link.href, location.origin).pathname });
      return;
    }
    const item = link?.closest('[data-cbn-campaign-product]');
    if (item && new URL(link.href, location.origin).pathname.includes('/products/')) {
      publish('cbn_halloween_product_click', { product_id: item.dataset.cbnCampaignProduct, position: Number(item.dataset.cbnCampaignPosition), destination: new URL(link.href, location.origin).pathname });
    }
    if (event.target.closest?.('[data-cbn-home-offer-open]')) publish('cbn_halloween_offer_open', { placement: 'home' });
  });
})();
